import { graphql, useStaticQuery } from "gatsby";
import React from "react";

import ArrowRight from "images/icons/arrow-right.inline.svg";
import GlobeIllustration from "images/program/open-day-bg.inline.svg";

import Image from "../../components/image";
import { Link } from "../../utils/customLink";

const ProgramOpenDay = () => {
  const { meetUpCollection, genericDetails } = useStaticQuery(graphql`
    query {
      meetUpCollection: allWpMeetUp {
        nodes {
          ...WpMeetUpFragment
        }
      }
      genericDetails: wp {
        globalProgramConfig: gviConfigSettings {
          acfGenericGlobalConfig {
            ...OpenDayGalleryFragment
          }
        }
      }
    }
  `);

  const meetUps = meetUpCollection?.nodes[0] ?? [];

  if (meetUps?.length < 1) {
    return <></>;
  }

  const meetUpTitle = meetUps.title;
  const meetUpLocation = meetUps.acfMeetUps.meetupLocation;
  const meetupDateTime = meetUps.acfMeetUps.meetupDateTime;

  const meetupTargetUri = meetUps.uri;

  const { genOpendayDescription, genOpendayImage } =
    genericDetails?.globalProgramConfig?.acfGenericGlobalConfig ?? {};

  const meetupDescription =
    genOpendayDescription ??
    "Join our open days to also get the chance to chat with our alumni. Sign up to book your spot now. We have limited availability.";

  const meetupImage = genOpendayImage?.sourceUrl ?? "";

  return (
    <>
      <div className="divide-y height-divider dark:hidden sm:hidden border-[0.5px] border-gray-standard w-11/12 mx-auto" />
      <section className="openday-section flex relative mx-auto pt-0 bg-white sm:bg-generic-bg dark:bg-gray-dark sm:min-h-fit overflow-hidden">
        <GlobeIllustration className="absolute -bottom-[9vw] -right-[10vw] w-1/2 hidden md:block opacity-20 dark:opacity-40 fill-generic-text dark:fill-gray-illustration z-0" />
        <div className="flex flex-col justify-center w-11/12 gap-5 mx-auto pt-14 sm:pb-14 sm:w-10/12 z-10">
          <div className="section-header pb-2">
            <div
              className="font-alice dark:font-body font-normal dark:font-light text-black-lighter dark:text-white text-[26px] sm:text-xlrg-sm"
              dangerouslySetInnerHTML={{
                __html: "Connect with us"
              }}
            />
          </div>
          <div className="grid grid-flow-col grid-cols-1 grid-rows-2 gap-0 overflow-hidden sm:py-6 sm:border-t-1 sm:border-b-1 border-gray-border sm:grid-rows-1 sm:grid-cols-2 sm:gap-20">
            <div className="openday-image row-span-1 col-span-2 sm:col-span-1 rounded-md object-cover object-center w-full h-56 xl:h-80">
              <Image
                imageAlt="Open Day Image"
                image={""}
                imageClass="w-full h-full bg-center bg-cover object-cover object-center rounded-md"
                sourceUrl={meetupImage}
              />
            </div>
            <div className="pb-6 sm:pb-12 flex flex-col justify-center md:pb-0 gap-y-4">
              <div className="font-alice dark:font-lato font-normal dark:!font-semibold text-std-med text-generic-text dark:text-white">
                {meetUpTitle}
              </div>
              <h3 className="text-xs !font-normal text-generic-text dark:text-gray-generic pl-2 border-l-2 border-red-light dark:border-green-standard">
                {meetUpLocation &&
                  meetupDateTime &&
                  [meetUpLocation, meetupDateTime?.split("at ")[0]]?.join(
                    " : "
                  )}

                {meetUpLocation && !meetupDateTime && meetUpLocation}
                {meetupDateTime?.split("at ")[0] &&
                  !meetUpLocation &&
                  meetupDateTime?.split("at ")[0]}

                <br />
                {meetupDateTime?.split(", ")?.slice(1)?.join(", ")
                  ? meetupDateTime?.split(", ")?.slice(1)?.join(", ")
                  : meetupDateTime?.split("at ")[1]}
              </h3>
              <h6
                className="!font-normal text-generic-text dark:text-gray-generic"
                dangerouslySetInnerHTML={{
                  __html: meetupDescription
                }}
              />

              <Link
                className={
                  "submit-button view-program-link group flex gap-2 h-10 mt-8 sm:mt-0 justify-center items-center w-full md:w-max px-12 tracking-wider rounded-sm"
                }
                to={meetupTargetUri}
              >
                <span>Sign up for free</span>
                <ArrowRight className="w-3 h-3 stroke-white dark:stroke-gray-darker dark:group-hover:stroke-green-standard group-hover:stroke-black-lighter ml-2" />
              </Link>
            </div>
          </div>
          <div className="divide-y height-divider hidden dark:block dark:sm:hidden mt-10 border-[0.5px] border-gray-standard" />
        </div>
      </section>
    </>
  );
};

export default ProgramOpenDay;
